export default __webpack_public_path__ + "static/media/laptop_and_mobile_agent.3449a65b.png";